import MapMaker from "../utils/MapMaker";
export default class BlockMap {

	static init() {

		let blockMaps = document.querySelectorAll('.map-inner');

		if (!blockMaps) {
			return;
		}

		window.addEventListener("googleMapApiLoaded", () => {
			blockMaps.forEach((blockMap) => {
				let markers = blockMap.querySelectorAll('.map-marker');

				if (blockMap.dataset.type === "static") {

					MapMaker.createStaticMap(blockMap, markers);

				} else {

					let map = MapMaker.createDynamicMap(blockMap);

					if (blockMap.dataset.zoom) {
						map.setZoom(parseInt(blockMap.dataset.zoom));
					}

					markers.forEach((m) => {
						MapMaker.createMarker(m, map);
					});

					MapMaker.updateBounds(map);
				}
			});
		});
	}
}
